"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOP_POLICY_COLUMNS = exports.DATE_TIME_FORMAT = void 0;
exports.DATE_TIME_FORMAT = 'MM/DD hh:mm A';
var TOP_POLICY_COLUMNS;
(function (TOP_POLICY_COLUMNS) {
    TOP_POLICY_COLUMNS["name"] = "name";
    TOP_POLICY_COLUMNS["duration"] = "duration";
    TOP_POLICY_COLUMNS["startTime"] = "startTime";
    TOP_POLICY_COLUMNS["percentage"] = "percentage";
})(TOP_POLICY_COLUMNS = exports.TOP_POLICY_COLUMNS || (exports.TOP_POLICY_COLUMNS = {}));
//# sourceMappingURL=constants.js.map